import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'; 
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';

import { ShopDetailsComponent } from '../pages/shop-details/shop-details.component';
import { RetailerDataStoreService } from '../service/retailer-data-store.service';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<ShopDetailsComponent> {

  constructor(private router: Router, private dialog: MatDialog, private retailerDataStore: RetailerDataStoreService) {}

  canDeactivate(
    component: ShopDetailsComponent, 
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(this.router.url.includes('/success')) {
      console.log('Navigating to landing page from success screen');
      this.retailerDataStore.setNavigateToLandingPage(true);
      return true;
    }

    if (component.isDataSaved || !this.retailerDataStore.getRetailer()) {
      this.retailerDataStore.setNavigateToLandingPage(true);
      return true;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: { message: 'You have unsaved changes. Are you sure you want to go back?' },
      disableClose: true
    });

    return dialogRef.afterClosed().pipe(
      map(result => {
        if (result) {
          console.log('User confirmed navigation away from unsaved changes');
          this.retailerDataStore.setNavigateToLandingPage(true);
          return true;
        } else {
          return false; 
        }
      })
    );
  }
}